import { CountInput } from 'components/Wizards/CountInput/CountInput'
import { useField } from 'formik'
import { ContentCount } from 'types'
import { ContentCountInputProps } from 'screens/Schedule/EditChannelsModal/Types'
import Styles from './ContentCountInput.module.scss'
import cx from 'classnames'
import { useAutopilotLimits } from 'hooks/useAutopilotLimits'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const ContentCountInput = ({ name, merged, ...props }: ContentCountInputProps) => {
  const mergedBrandPlanSettings = useFlipperFlag('merged_brand_plan_settings')
  const [field, , { setValue }] = useField<ContentCount>(name)

  const { maxPostsPerChannel } = useAutopilotLimits()

  if (!field.value) {
    return null
  }

  return (
    <CountInput
      value={field.value.count}
      onChange={(count) => setValue({ ...field.value, count })}
      name={name}
      flex
      min={0}
      max={maxPostsPerChannel}
      className={cx(Styles.wrapper, Styles[props.size || 'lg'])}
      merged={merged ?? mergedBrandPlanSettings}
      {...props}
    />
  )
}
